// Get locale storage
// ====================================================================================================
export const storageActionGet = () => {
  const wl = window.localStorage.getItem('wishlist')
  return wl ? JSON.parse(wl) : []
}

// Set locale storage
// ====================================================================================================
export const storageActionSet = (data) => {
  window.localStorage.setItem('wishlist', JSON.stringify(data))
}
